import { MessageBubble, MessageContainer } from './ChatMessage.styles';

export interface ChatMessageProps {
  id: string;
  type: ChatMessageType;
  content: string | React.ReactNode;
  isUser?: boolean;
}

export enum ChatMessageType {
  MESSAGE,
  COMPONENT,
}

export function ChatMessage({ id, type, content, isUser }: ChatMessageProps) {
  if (type === ChatMessageType.COMPONENT) {
    return content;
  }

  return (
    <MessageContainer $isUser={isUser} data-testid={id}>
      <MessageBubble $isUser={isUser}>{content}</MessageBubble>
    </MessageContainer>
  );
}
